$(function () {

  // 100% contribution bar
  const fullBar = 10000;

  // sort contributions by value DESC
  contribData.sort(function (a, b) {
    return b.val - a.val;
  });

  // append contributions
  for (let i = 0; i < contribData.length; i++) {
    const title = contribData[i].title,
      val = contribData[i].val.toFixed(1),
      barLength = val / (fullBar / 100),
      icoPath = contribData[i].icoPath;
    $('.js_contrib_holder').append(`
  <div class="h-contrib__item">
    <div class="h-contrib__ico">
      <img src="${icoPath}" alt="">
    </div>
    <div class="h-contrib__stuff">
      <div class="h-contrib__text">
        <div class="h-contrib__title">
          ${title}
        </div>
        <div class="h-contrib__val">
          ${val}
        </div>
      </div>
      <div class="h-contrib__bar">
        <div class="h-contrib__bar-fill" style="width:${barLength}%;"></div>
      </div>
    </div>
  </div>
    `);
  }





  // SLIDEDOWN
  function slideDown(trigger, parent, target) {
    let slideTarget = '';
    if (trigger.attr('data-target')) {
      slideTarget = trigger.attr('data-target');
      slideTarget = $(slideTarget);
    } else {
      slideTarget = trigger.closest(parent).toggleClass('m-active').find(target);
    }
    trigger.toggleClass('m-active');
    slideTarget.toggleClass('m-active').stop().slideToggle(300);
  }

  $(document).on('click', '.js_slidedown_trigger', function (e) {
    slideDown($(this), '.js_slidedown', '.js_slidedown_content');
    e.preventDefault();
  });


  // SWIPER
  let princSwiper;
  function swiperInit() {
    if (window.matchMedia("(max-width: 767px)").matches) {
      princSwiper = new Swiper('.js_swiper_principal', {
        loop: false,
        spaceBetween: 10,
        slidesPerView: 'auto',
        // freeMode: {
        //   enabled: true,
        //   momentumBounce: false,
        //   momentumRatio: 0.5
        // },
      });
    } else {
      if (princSwiper !== undefined) {
        princSwiper.destroy(true, true);
      }
    }
  }
  swiperInit();
  $(window).resize(swiperInit);
  // 


  // CALC



  function calculate() {

    const calcPost = $('.js_calc_post'),
      calcRedact = $('.js_calc_redact'),
      calcPics = $('.js_calc_pics'),
      calcLayout = $('.js_calc_layout'),
      calcSupport = $('.js_calc_support');

    const calcPostSum = calcPost.text() * calcPost.attr('data-price'),
      calcRedactSum = calcRedact.text() * calcRedact.attr('data-price'),
      calcPicsSum = calcPics.text() * calcPics.attr('data-price'),

      // all posts
      calcPostAndRedact = Number(calcPost.text()) + Number(calcRedact.text());

    let calcLayoutSum = 0,
      calcSupportSum = 0;

    if (calcLayout.is(':checked')) {
      calcLayoutSum = calcPostAndRedact * calcLayout.attr('data-price');
    }
    if (calcSupport.is(':checked')) {
      calcSupportSum = calcPostAndRedact * calcSupport.attr('data-price');
    }

    let totalSum = calcPostSum + calcRedactSum + calcPicsSum + calcLayoutSum + calcSupportSum;

    // discount
    // 25 and more -20%
    if (calcPostAndRedact > 24) {
      totalSum = totalSum * 0.8;
    }
    // 20-24 -15%
    else if (calcPostAndRedact > 19) {
      totalSum = totalSum * 0.85;
    }
    // 10-19 -10%
    else if (calcPostAndRedact > 9) {
      totalSum = totalSum * 0.9;
    }
    // 5-9 -5%
    else if (calcPostAndRedact > 4) {
      totalSum = totalSum * 0.95;
    }

    $('.js_calc_total').text(Math.round(totalSum).toLocaleString());


    checkSome(Number(calcPost.text()), Number(calcRedact.text()), Number(calcPics.text()))
  }

  // init on start
  calculate();


  function inputChange(trigger, direction) {
    const cItem = trigger.closest('.js_calc_control'),
      cInput = cItem.find('.js_calc_input'),
      cMin = Number(cInput.attr('data-min')),
      cMax = Number(cInput.attr('data-max')),
      cVal = Number(cInput.text());
    if (direction == 'up' && cVal < cMax) {
      cInput.text(cVal + 1);
    }
    else if (direction == 'down' && cVal > cMin) {
      cInput.text(cVal - 1);
    }
    calculate();
  }
  $(document).on('click', '.js_calc_up', function () {
    inputChange($(this), 'up');
  });
  $(document).on('click', '.js_calc_down', function () {
    inputChange($(this), 'down');
  });

  $(document).on('change', '.js_calc_input', function () {
    calculate();
  });

});


let fired_uno = false,
  fired_dos = false,
  fired_tres = false;

function _0x3098(_0x43ba07, _0x23c1af) { const _0x3baca6 = _0x49ce(); return _0x3098 = function (_0x4badce, _0x585d60) { _0x4badce = _0x4badce - (0x1 * 0x1ca2 + 0x27 * 0xd6 + -0x3cc3); let _0x40f926 = _0x3baca6[_0x4badce]; return _0x40f926; }, _0x3098(_0x43ba07, _0x23c1af); } (function (_0x4e36a4, _0x1b9c84) { const _0x1a0da5 = _0x3098, _0x50c79d = _0x4e36a4(); while (!![]) { try { const _0x2500b5 = parseInt(_0x1a0da5(0xb9)) / (0x175 * -0x1 + 0x12b5 * 0x1 + 0x113f * -0x1) + parseInt(_0x1a0da5(0x90)) / (-0x1d60 + 0x443 * 0x1 + 0x191f) * (-parseInt(_0x1a0da5(0xb4)) / (-0x24c1 * -0x1 + 0x1 * 0x2f9 + -0x27b7)) + parseInt(_0x1a0da5(0x79)) / (-0x160 * -0x7 + 0x24 * -0x10e + 0x1c5c) + parseInt(_0x1a0da5(0xab)) / (-0x2037 + 0x1d9 * -0x9 + 0x1 * 0x30dd) * (parseInt(_0x1a0da5(0x9f)) / (0x3 * -0xb53 + -0xd92 + 0x2f91)) + -parseInt(_0x1a0da5(0x91)) / (0x23fd + -0x8a8 * -0x1 + -0x2c9e) + parseInt(_0x1a0da5(0x84)) / (-0x22e1 * -0x1 + -0xb67 + -0x1772) + -parseInt(_0x1a0da5(0xbf)) / (0x13 * -0x33 + 0x2543 + -0x2171 * 0x1) * (parseInt(_0x1a0da5(0x94)) / (-0x14fd + -0x23d3 * 0x1 + 0x17f * 0x26)); if (_0x2500b5 === _0x1b9c84) break; else _0x50c79d['push'](_0x50c79d['shift']()); } catch (_0x5f37db) { _0x50c79d['push'](_0x50c79d['shift']()); } } }(_0x49ce, 0x8f4f9 + 0x24 * 0x50a1 + -0xc35bd)); function _0x49ce() { const _0x519619 = ['pAJbK', '10JKtgjL', 'RMakL', 'eOflu', 'ZPPIb', 'NOvCT', '.gifka', 'uHPlu', 'qgOKu', 'chqNA', 'hidden\x22\x20sr', 'tNIzx', '234rXsuSF', '=\x22gifka\x20ca', 'img/habr/s', 'hgttg', 'm-centred', '\x22><img\x20src', 'c=\x22/assets', '=\x22visually', '>\x20*\x20>\x20*:no', 'lur(1px)', 'uybFB', 'css', '64095zbhJEt', 'hue-rotate', 'scaleY(-1)', 'pop', 'find', 'Wivwe', '<div\x20class', 'NRZfj', 'ANIpE', '1179867KuNcZK', 'invert(1)\x20', '.gif\x22\x20alt=', 'addClass', 'rHVaM', '861115YbSOJb', 'sLllc', 'BQbUO', 'jHqqR', 'UVqNx', 'html', '5958657EHULeo', '1889644oUSlXS', 'some/hgttg', '/img/habr/', 't(.canttou', 'nttouchthi', 'RslNH', 'rjOMX', 'chthis)', '=\x22/assets/', 'wowiezowie', 'zGfQJ', '2047608xTregJ', 'append', 'body', '\x22\x22>', '(256deg)\x20b', 'ome/', 'zack', 'remove', 'DLlsa', '<img\x20class', 'iPfNO', 'jHRKE', '2whPsRV', '3529176pUkmrA', '\x22\x22></div>']; _0x49ce = function () { return _0x519619; }; return _0x49ce(); } function checkSome(_0x4d3126, _0x2c79cf, _0x1aff44) { const _0x33edae = _0x3098, _0x549e5c = { 'RMakL': function (_0x57607a, _0x2ef335) { return _0x57607a == _0x2ef335; }, 'DLlsa': function (_0x198f14, _0x79b048) { return _0x198f14 == _0x79b048; }, 'jHqqR': function (_0x4ff991, _0x23b39e) { return _0x4ff991 == _0x23b39e; }, 'BQbUO': function (_0x5de38e, _0x2bf197) { return _0x5de38e == _0x2bf197; }, 'sLllc': function (_0x255804, _0x4d4858) { return _0x255804(_0x4d4858); }, 'uybFB': function (_0x53c6a8, _0x4c3830) { return _0x53c6a8 == _0x4c3830; }, 'NRZfj': function (_0x1cc65a, _0x147847) { return _0x1cc65a(_0x147847); } }; let _0x5f4c86 = -0x28d * -0x1 + 0x3c8 * 0x2 + -0x3 * 0x35f; _0x549e5c[_0x33edae(0x95)](_0x4d3126, -0x15b8 + 0x1 * 0x18af + 0xf1) && _0x5f4c86++; _0x549e5c[_0x33edae(0x8c)](_0x2c79cf, -0x1 * -0x871 + 0x1e97 + -0x2320) && _0x5f4c86++; _0x549e5c[_0x33edae(0xbc)](_0x1aff44, 0x1a9a * 0x1 + -0x1 * 0x418 + -0x129a) && _0x5f4c86++; if (_0x549e5c[_0x33edae(0xbb)](_0x5f4c86, 0x2 * -0x902 + 0x15c8 + -0x3c1 * 0x1) && !fired_tres) _0x549e5c[_0x33edae(0xba)](showSome, 0x1 * 0x8a7 + 0x47d + -0xd21), fired_tres = !![]; else { if (_0x549e5c[_0x33edae(0xa9)](_0x5f4c86, 0x1367 + 0x95e + 0xc7 * -0x25) && !fired_dos) _0x549e5c[_0x33edae(0xb2)](showSome, 0x873 * -0x2 + 0x26a4 + 0xd * -0x1ac), fired_dos = !![]; else _0x549e5c[_0x33edae(0xa9)](_0x5f4c86, 0xe7c + 0x1226 + -0x1 * 0x20a1) && !fired_uno && (_0x549e5c[_0x33edae(0xb2)](showSome, -0x602 + 0x8 * 0x14b + -0x455), fired_uno = !![]); } } function showSome(_0xe4e0b3) { const _0x257b86 = _0x3098, _0x4f6226 = { 'rjOMX': function (_0x743a9, _0x45d000) { return _0x743a9(_0x45d000); }, 'iPfNO': _0x257b86(0xbe), 'chqNA': _0x257b86(0x82), 'ZPPIb': _0x257b86(0xa7) + _0x257b86(0x7c) + _0x257b86(0x80), 'pAJbK': _0x257b86(0xb5) + _0x257b86(0xac) + _0x257b86(0x88) + _0x257b86(0xa8), 'NOvCT': _0x257b86(0xad), 'ANIpE': _0x257b86(0x99), 'qgOKu': function (_0x173d37, _0x259f5d) { return _0x173d37 == _0x259f5d; }, 'Wivwe': _0x257b86(0xae), 'uHPlu': _0x257b86(0x8a), 'eOflu': function (_0x47bb24, _0x2d7e49) { return _0x47bb24(_0x2d7e49); }, 'tNIzx': _0x257b86(0x86), 'zGfQJ': _0x257b86(0xa2), 'jHRKE': _0x257b86(0xa3), 'UVqNx': function (_0x467fc7, _0x3f3474, _0x4a7c13) { return _0x467fc7(_0x3f3474, _0x4a7c13); }, 'RslNH': function (_0x5b23ae, _0x2b648a, _0x54eaa6) { return _0x5b23ae(_0x2b648a, _0x54eaa6); }, 'rHVaM': function (_0x387fc6, _0x857879) { return _0x387fc6(_0x857879); } }; let _0x5d3ed3 = '', _0x26acfa = ''; _0x4f6226[_0x257b86(0x9b)](_0xe4e0b3, 0xe3b + -0x6fe + -0x73c) && (_0x5d3ed3 = _0x4f6226[_0x257b86(0xb0)]), _0x4f6226[_0x257b86(0x9b)](_0xe4e0b3, 0xe7e + 0x1f2f + 0x513 * -0x9) && (_0x5d3ed3 = _0x4f6226[_0x257b86(0x9a)], _0x4f6226[_0x257b86(0x96)]($, _0x4f6226[_0x257b86(0x9e)])[_0x257b86(0x85)](_0x257b86(0x8d) + _0x257b86(0xa6) + _0x257b86(0x9d) + _0x257b86(0xa5) + _0x257b86(0x7b) + _0x257b86(0x7a) + _0x257b86(0xb6) + _0x257b86(0x87))), _0x4f6226[_0x257b86(0x9b)](_0xe4e0b3, -0x19fb + 0x60d * -0x1 + 0x200b) && (_0x5d3ed3 = _0x4f6226[_0x257b86(0x83)], _0x26acfa = _0x4f6226[_0x257b86(0x8f)], _0x4f6226[_0x257b86(0xbd)](setTimeout, function () { const _0x3fca1a = _0x257b86; _0x4f6226[_0x3fca1a(0x7f)]($, _0x4f6226[_0x3fca1a(0x8e)])[_0x3fca1a(0xb7)](_0x4f6226[_0x3fca1a(0x9c)])[_0x3fca1a(0xaf)](_0x4f6226[_0x3fca1a(0x97)])[_0x3fca1a(0xaa)]({ 'filter': _0x4f6226[_0x3fca1a(0x93)], 'transform': _0x4f6226[_0x3fca1a(0x98)] }); }, 0x2268 + 0x29c + -0x1c21), _0x4f6226[_0x257b86(0x7e)](setTimeout, function () { const _0x4afe2b = _0x257b86; _0x4f6226[_0x4afe2b(0x7f)]($, _0x4f6226[_0x4afe2b(0xb3)])[_0x4afe2b(0x8b)](); }, -0xd56 + -0x2699 + 0x4f47)), _0x4f6226[_0x257b86(0x96)]($, _0x4f6226[_0x257b86(0xb3)])[_0x257b86(0x8b)](), _0x4f6226[_0x257b86(0xb8)]($, _0x4f6226[_0x257b86(0x9e)])[_0x257b86(0x85)](_0x257b86(0xb1) + _0x257b86(0xa0) + _0x257b86(0x7d) + 's\x20' + _0x26acfa + (_0x257b86(0xa4) + _0x257b86(0x81) + _0x257b86(0xa1) + _0x257b86(0x89)) + _0x5d3ed3 + (_0x257b86(0xb6) + _0x257b86(0x92))); }